import React from 'react'
import './Veiculosecia.scss';
import VeiculoseciaHeader from '../../components/Veiculosecia/VeiculoseciaHeader';
import VeiculoseciaFooter from '../../components/Veiculosecia/VeiculoseciaFooter';
import { Outlet } from 'react-router-dom'

function Veiculosecia() {
    return (
        <div className='app-container'>
            <VeiculoseciaHeader />
            <main className='veiculosecia'>
                <Outlet />
            </main>
            <VeiculoseciaFooter />
        </div>
    )
}

export default Veiculosecia;
